import { AppBar, Button, SxProps, Theme, Toolbar } from '@mui/material';

import { useLanguage } from '../../hooks';

const customStyles: Record<string, SxProps<Theme>> = {
  appBar: {
    top: 'auto',
    bottom: 0,
    padding: '5px 0px',
  },
  toolBar: {
    display: 'flex',
    justifyContent: 'flex-end',
  },
  button: {
    padding: '8px 28px',
  },
};

interface FormSignatureBuilderBarProps {
  onConfirm: () => void;
  disabled: boolean;
}

export default function FormSignatureBuilderBar({
  onConfirm,
  disabled,
}: FormSignatureBuilderBarProps) {
  const lang = useLanguage();
  return (
    <AppBar
      position='fixed'
      color='inherit'
      sx={customStyles.appBar}
    >
      <Toolbar sx={customStyles.toolBar}>
        <Button
          color='primary'
          variant='contained'
          sx={customStyles.button}
          onClick={onConfirm}
          disabled={disabled}
        >
          {lang.formSignatureBuilder.save}
        </Button>
      </Toolbar>
    </AppBar>
  );
}
